import axios from "axios";
import { Get, Post } from "../server";

// 查询
export const getIntegralWorks = () => {
    return Get("/admin/creditsConf/dailyTasks",);
};

export const updateIntegralWorksList = (taskId: any, params: any) => {
    return axios({
        url: `/admin/creditsConf/dailyTask/${taskId}`,
        method: "put",
        headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + localStorage.getItem("come-to-chant-token"),
        },
        data: params,
        baseURL: process.env.REACT_APP_BASE_URL,
    });
}